import { Alert, Empty, Typography } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDiagnosticsHistoryPanel } from './hooks/useDiagnosticsHistoryPanel';
import styles from './DiagnosticsHistoryPanel.module.css';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

export interface DiagnosticsHistoryPanelProps {
  organizationId: string;
  assetId: string;
}

export const DiagnosticsHistoryPanel: FC<DiagnosticsHistoryPanelProps> = ({
  organizationId,
  assetId,
}) => {
  const { t } = useTranslation('assets');
  const {
    columns,
    rows,
    total,
    page,
    pageSize,
    isLoading,
    isError,
    onPageChange,
  } = useDiagnosticsHistoryPanel(organizationId, assetId);

  return (
    <section className={styles.panel}>
      <div className={styles.header}>
        <Typography.Title level={4} className={styles.title}>
          {t('detail.commands.diagnosticsHistory.title')}
        </Typography.Title>
        <p className={styles.description}>
          {t('detail.commands.diagnosticsHistory.description')}
        </p>
      </div>

      {isError ? (
        <Alert
          type="error"
          showIcon
          message={t('detail.commands.diagnosticsHistory.loadError')}
        />
      ) : (
        <div className={styles.tableWrap}>
          <EvimoTable
            className={styles.table}
            size="middle"
            rowKey="id"
            loading={isLoading}
            columns={columns}
            dataSource={rows}
            pagination={{
              current: page,
              pageSize,
              total,
              hideOnSinglePage: false,
              showSizeChanger: false,
              onChange: onPageChange,
            }}
            locale={{
              emptyText: (
                <div className={styles.emptyBody}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t('detail.commands.diagnosticsHistory.empty')}
                  />
                </div>
              ),
            }}
          />
        </div>
      )}
    </section>
  );
};
